<template>
  <Toasts :items="items" horizontal="center" vertical="top" color="error" />
</template>

<script lang="ts">
import Toasts from '@/components/Toasts.vue'
import { queue } from '@/lib/logging'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Toasts,
  },
})
export default class ErrorToasts extends Vue {
  public get items() {
    return queue.value.filter((item) => item.level === 'error')
  }
}
</script>
